import { BiLogger } from '../../../Hoc/BiLogger/BiLoggerProvider';
import { AppDispatch } from '../../../../store';
import { onReadyToPayChange } from '../../../../actions/googlePay/onReadyToPayChange';
import { GooglePayReadyToPayChangeResponse } from '../types';
import { PaymentsButtonPlace } from '../../../../types/PaymentsButtonViewConfig';

type CreateOnReadyToPayChangeParams = {
  biLogger: BiLogger;
  dispatch: AppDispatch;
  place: PaymentsButtonPlace;
};

type CreateOnReadyToPayChange = (
  params: CreateOnReadyToPayChangeParams,
) => (readyToPayState: GooglePayReadyToPayChangeResponse) => Promise<{}>;

export const createOnReadyToPayChange: CreateOnReadyToPayChange =
  ({ place, biLogger, dispatch }) =>
  (readyToPayState) => {
    return dispatch(onReadyToPayChange({ biLogger, readyToPayState, place })).unwrap();
  };
